import { SupportedUserRoles } from '@insurancemenu/imenu-components-lib/dist/types';

export enum AgencyType {
  AGENCY = 'AGENCY',
  GA = 'GA',
  EF = 'EF',
  TPA = 'TPA',
}

export interface HeaderUserInfo {
  firstName: string;
  lastName: string;
  affiliation: string;
  sponsorName: string;
  sponsorId: string;
  userRoles: SupportedUserRoles[];
  agencyId: string;
  imAgencyId: string;
  agencyType: AgencyType;
}

export interface User {
  npn?: string;
}

export interface SEUser {
  firstName: string;
  middleName?: string;
  lastName: string;
  email: string;
  title?: string;
  id?: string;
  userType: UserType | null;
  groupId: string;
  periodId?: string;
  subscriberId?: string;
  telephone?: string;
}

export enum UserStatus {
  INVITED = 'INVITED',
  ACTIVE = 'ACTIVE',
  TERMINATED = 'TERMINATED',
}

export interface FullUser {
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  title: string;
  id: string;
  telephone: string;
  status: UserStatus;
  npn: string;
  userTypes: UserType[];
}

export interface InputEmployer {
  firstName: string;
  middleName: string;
  lastName: string;
  telephone: string;
  title: string;
  groupId: string;
}

export type UserType = 'BROKER' | 'EMPLOYER' | 'EMPLOYEE';

export interface UserInfo {
  firstName: string;
  lastName: string;
  telephone: string;
  npn?: string;
}

export enum CelticType {
  CELTICS = 'CELTICS',
  IM_CELTICS = 'IM_CELTICS',
  BROWSING_CELTICS = 'BROWSING_CELTICS',
  UNDERWRITING_CELTICS = 'UNDERWRITING_CELTICS',
  RFQ_PRODUCT_CELTICS = 'RFQ_PRODUCT_CELTICS',
  RFQ_RESPONSE_CELTICS = 'RFQ_RESPONSE_CELTICS',
  RENEWAL_CELTICS = 'RENEWAL_CELTICS',
  CHANNEL_CELTICS = 'CHANNEL_CELTICS',
  ACCOUNT_REP_CELTICS = 'ACCOUNT_REP_CELTICS',
}

export enum ProducerSource {
  WEB = 'WEB',
  SYNC = 'SYNC',
}

export enum ProducerStatus {
  ACTIVE = 'ACTIVE',
  TERMINATED = 'TERMINATED',
}

export interface SponsorSpecificProducerData {
  tin?: string;
  npn?: string;
  email?: string;
}

export interface Producer {
  id: string;
  name: string;
  source: ProducerSource;
  status: ProducerStatus;
  sponsorSpecificData: SponsorSpecificProducerData;
  appointedStates: string[];
}
